<template>
	<div class="tpl send-appointment-wrap">
		<mt-header title="发布邀约" fixed>
		  <router-link :to="{name:'appointment-list'}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button  icon="more" slot="right"></mt-button>
		</mt-header>
		<appoint-theme :uid="uid" @chooseTheme="getChoosedTheme"></appoint-theme>
		<pre-money @chooseMoney="getChoosedMoney"></pre-money>
		<appoint-gift @chooseGift="getChoosedGift"></appoint-gift>
		<div class="appointment-btn">
			<button @click="nextStep">下一步</button>
		</div>
	</div>
</template>

<script>
	
	import AppointTheme from "../Common/AppointTheme"
	import PreMoney from "../Common/PreMoney"
	import AppointGift from "../Common/AppointGift"
	
	export default{
		name:"send-appointment",
		data(){
			return{
				uid:"",
				choosedSincerity:"",	//约会主题
				choosedMoney:"",	//选择的预付金
				choosedGift:"",		//选择的礼物列表
			}
		},
		components:{
			PreMoney,AppointTheme,AppointGift
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
		},
		methods:{
			getChoosedTheme(theme){
				console.log(theme)
				this.choosedSincerity = theme;
			},
			getChoosedMoney(money){
				this.choosedMoney = money;
			},
			getChoosedGift(gift){
				this.choosedGift = gift;
			},
			nextStep(){
				console.log(this.choosedSincerity);
				console.log(this.choosedMoney);
				console.log(this.choosedGift);
				this.$router.push({
					name:"send-edit-info",
					params:{
						theme:this.choosedSincerity,
						money:this.choosedMoney,
						gifts:this.choosedGift
					}
				})
			}
		}
	}
</script>

<style scoped>
	.send-appointment-wrap{
		padding-top: 2.5rem;
		background: #fff;
	}
	.appointment-btn{
		padding: 0.5rem 1.5rem 1.5rem;
	}
	.appointment-btn button{
		width: 100%;
		height: 2.5rem;
		background: linear-gradient(to right,#7644fa,#9d7cff);
		border-radius: 5px;
		border: 0;
		outline: 0;
		color: #fff;
		font-size: 0.8rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/SendAppointment.vue